<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div class="container-fluid csReport">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{checkModuleIndex('DCSR', 'R', constAccessType.view, '', -1)}} {{this.getLanguage["SMB"]["DCSR"]}}</h2>

                        <div class="custom-tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol' v-if="getUserInfo.AT !== 4 && !hideBrand">
                                <span class='searchLabel'>{{this.getLanguage["MTA"]["BN"]}} :</span>
                                <customtreeselect :multiple="true"
                                            :limit="1"
                                            valueConsistsOf="LEAF_PRIORITY"
                                            :disable-branch-nodes="false"
                                            :limitText="count => `+${count}`"
                                            :options="dd_agentgroup"
                                            :defaultExpandLevel="Infinity"
                                            :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                            v-model="SearchAGI"
                                            @input="AgentGroupChangefs" />
                            </div>
                             <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['SAGT']}} :</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :key="rtSubBrand"
                                            :cacheOptions="false"
                                            :load-options="loadSubBrandOptions"
                                            :defaultOptions="ddDefaultSubBrand"
                                            :options="dd_subagentgroup"
                                            :noResultsText="this.getLanguage['GL']['NRF']"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('GL.SAGT')"
                                            v-model="str_FV[1].FV"
                                            :disabled="disableSubDD"
                                            @input="SubAgentGroupChangefs" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['SD']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="center"
                                                   :auto-apply="true"
                                                   v-model="str_FV[2].FV"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="str_FV[2].FV.startDate != ''">
                                            <CInput size="sm"
                                                    :value="str_FV[2].FV.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['ED']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="str_FV[2].FV"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="str_FV[2].FV.endDate != ''">
                                            <CInput size="sm"
                                                    :value="str_FV[2].FV.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" @shortkey="newsearch()" class='searchBtn' ref="search" size="sm" block color="success" @click="newsearch()"><span class='searchIcon cil-search'></span><span>{{this.getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>
        
            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>{{ this.getLanguage["SMB"]["DCSRL"] }}</strong>
                    <div class="pageBtn">
                        <CButton v-if="checkModuleAccess2(constAccessType.edit)" class="btnExcel" @click="saveToExcel()">
                            <img src="/Content/img/excel.png" width="20" style="padding-left:2px">
                            {{this.getLanguage["BTN"]["DL"]}}
                        </CButton>
                    </div>
                </header>
                <!--<header class="table-header">-->
                <!-- <strong>{{this.getLanguage['MTA']['DRL']}}</strong> -->
                <!--<strong>{{this.getLanguage["DCSR"]["DCSRL"]}}</strong>
                </header>-->
                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th rowspan="2" id="nestedTable" style="border-top-left-radius: 5px; border-bottom-left-radius: 5px; border-bottom: solid 1px #9D9DAB;">{{this.getLanguage["GL"]["NO"]}}</th>
                                <th rowspan="2" id="nestedTable" style="border-right: solid 1px #9D9DAB; border-bottom: solid 1px #9D9DAB;">{{this.getLanguage["DCSR"]["DA"]}}</th>
                                <th rowspan="2" id="nestedTable" style="border-right: solid 1px #9D9DAB; border-bottom: solid 1px #9D9DAB;">{{this.getLanguage["DCSR"]["AM"]}}</th>
                                <th rowspan="2" id="nestedTable" class="tableCtnRight" style="border-right: solid 1px #9D9DAB;">{{this.getLanguage["DCSR"]["R"]}}</th>
                                <th colspan="3" id="nestedTable" style="border-right: solid 1px #9D9DAB; border-bottom: solid 1px #9D9DAB; color:#fff">{{this.getLanguage["DCSR"]["D"]}}</th>
                                <th colspan="5" id="nestedTable" style="border-right: solid 1px #9D9DAB; border-bottom: solid 1px #9D9DAB; color: #fff">{{this.getLanguage["DCSR"]["P"]}}</th>
                                <th colspan="2" id="nestedTable" style="border-top-right-radius: 5px; border-bottom: solid 1px #9D9DAB; color: #fff">{{this.getLanguage["DCSR"]["L"]}}</th>
                            </tr>
                            <tr>
                                <th id="nestedTableR2" class="tableCtnRight">{{this.getLanguage["DCSR"]["FD"]}}</th>
                                <th id="nestedTableR2" class="tableCtnRight">{{this.getLanguage["DCSR"]["D"]}}</th>
                                <th id="nestedTableR2" class="tableCtnRight" style="border-right: solid 1px #9D9DAB;">{{this.getLanguage["DCSR"]["UD"]}}</th>
                                <th id="nestedTableR2" class="tableCtnRight">{{this.getLanguage["DCSR"]["FD"]}}</th>
                                <th id="nestedTableR2" class="tableCtnRight">{{this.getLanguage["DCSR"]["ED"]}}</th>
                                <th id="nestedTableR2" class="tableCtnRight">{{this.getLanguage["DCSR"]["AFF"]}}</th>
                                <th id="nestedTableR2" class="tableCtnRight">{{this.getLanguage["DCSR"]["AR"]}}</th>
                                <th id="nestedTableR2" class="tableCtnRight" style="border-right: solid 1px #9D9DAB;">{{this.getLanguage["DCSR"]["DLS"]}}</th>
                                <th id="nestedTableR2" class="tableCtnRight" style="border-right: solid 1px #9D9DAB;">{{this.getLanguage["DCSR"]["M"]}}</th>
                                <th id="nestedTableR2" class="tableCtnRight" style="border-bottom-right-radius: 5px;">{{this.getLanguage["DCSR"]["A"]}}</th>
                            </tr>

                            <tr v-if="getUserInfo.AT == 4 && str_FV[1].FV">
                                <th colspan="2" id="nestedTableR3" class="" style="border-bottom-left-radius: 5px;border-top-left-radius:5px;">{{this.getLanguage["DCSR"]["T"]}}</th>
                                <th rowspan="1" id="nestedTableR3" class="tableCtnRight" style="border-right: solid 1px #9D9DAB;">{{ formatNumber(arry_dcstl.AM, 0) }}</th>
                                <th rowspan="1" id="nestedTableR3" class="tableCtnRight" style="border-right: solid 1px #9D9DAB;">{{ formatNumber(arry_dcstl.RC, 0) }}</th>
                                <th rowspan="1" id="nestedTableR3" class="tableCtnRight">{{ formatNumber(arry_dcstl.FDC, 0) }}</th>
                                <th rowspan="1" id="nestedTableR3" class="tableCtnRight">{{ formatNumber(arry_dcstl.DC, 0) }}</th>
                                <th rowspan="1" id="nestedTableR3" class="tableCtnRight" style="border-right: solid 1px #9D9DAB;">{{ formatNumber(arry_dcstl.UDC, 0) }}</th>
                                <th rowspan="1" id="nestedTableR3" class="tableCtnRight">{{ formatNumber(arry_dcstl.PFDC, 0) }}</th>
                                <th rowspan="1" id="nestedTableR3" class="tableCtnRight">{{ formatNumber(arry_dcstl.PEDC, 0) }}</th>
                                <th rowspan="1" id="nestedTableR3" class="tableCtnRight">{{ formatNumber(arry_dcstl.AFFC, 0) }}</th>
                                <th rowspan="1" id="nestedTableR3" class="tableCtnRight">{{ formatNumber(arry_dcstl.ARC, 0) }}</th>
                                <th rowspan="1" id="nestedTableR3" class="tableCtnRight" style="border-right: solid 1px #9D9DAB;">{{ formatNumber(arry_dcstl.DLSC, 0) }}</th>
                                <th rowspan="1" id="nestedTableR3" class="tableCtnRight" style="border-right: solid 1px #9D9DAB;">{{ formatNumber(arry_dcstl.MC, 0) }}</th>
                                <th rowspan="1" id="nestedTableR3" class="tableCtnRight" style="border-bottom-right-radius: 5px;border-top-right-radius:5px">{{ formatNumber(arry_dcstl.AC, 0) }}</th>
                            </tr>
                            <tr v-else="str_FV[0].FV">
                                <th colspan="2" id="nestedTableR3" class="" style="border-bottom-left-radius: 5px;border-top-left-radius:5px;">{{this.getLanguage["DCSR"]["T"]}}</th>
                                <th rowspan="1" id="nestedTableR3" class="tableCtnRight" style="border-right: solid 1px #9D9DAB;">{{ formatNumber(arry_dcstl.AM, 0) }}</th>
                                <th rowspan="1" id="nestedTableR3" class="tableCtnRight" style="border-right: solid 1px #9D9DAB;">{{ formatNumber(arry_dcstl.RC, 0) }}</th>
                                <th rowspan="1" id="nestedTableR3" class="tableCtnRight">{{ formatNumber(arry_dcstl.FDC, 0) }}</th>
                                <th rowspan="1" id="nestedTableR3" class="tableCtnRight">{{ formatNumber(arry_dcstl.DC, 0) }}</th>
                                <th rowspan="1" id="nestedTableR3" class="tableCtnRight" style="border-right: solid 1px #9D9DAB;">{{ formatNumber(arry_dcstl.UDC, 0) }}</th>
                                <th rowspan="1" id="nestedTableR3" class="tableCtnRight">{{ formatNumber(arry_dcstl.PFDC, 0) }}</th>
                                <th rowspan="1" id="nestedTableR3" class="tableCtnRight">{{ formatNumber(arry_dcstl.PEDC, 0) }}</th>
                                <th rowspan="1" id="nestedTableR3" class="tableCtnRight">{{ formatNumber(arry_dcstl.AFFC, 0) }}</th>
                                <th rowspan="1" id="nestedTableR3" class="tableCtnRight">{{ formatNumber(arry_dcstl.ARC, 0) }}</th>
                                <th rowspan="1" id="nestedTableR3" class="tableCtnRight" style="border-right: solid 1px #9D9DAB;">{{ formatNumber(arry_dcstl.DLSC, 0) }}</th>
                                <th rowspan="1" id="nestedTableR3" class="tableCtnRight" style="border-right: solid 1px #9D9DAB;">{{ formatNumber(arry_dcstl.MC, 0) }}</th>
                                <th rowspan="1" id="nestedTableR3" class="tableCtnRight" style="border-bottom-right-radius: 5px;border-top-right-radius:5px">{{ formatNumber(arry_dcstl.AC, 0) }}</th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th rowspan="2" id="nestedTable" style="border-top-left-radius: 5px; border-bottom-left-radius: 5px; border-bottom: solid 1px #9D9DAB;">{{this.getLanguage["GL"]["NO"]}}</th>
                                <th rowspan="2" id="nestedTable" style="border-right: solid 1px #9D9DAB; border-bottom: solid 1px #9D9DAB;">{{this.getLanguage["DCSR"]["DA"]}}</th>
                                <th rowspan="2" id="nestedTable" style="border-right: solid 1px #9D9DAB; border-bottom: solid 1px #9D9DAB;">{{this.getLanguage["DCSR"]["AM"]}}</th>
                                <th rowspan="2" id="nestedTable" class="tableCtnRight" style="border-right: solid 1px #9D9DAB;">{{this.getLanguage["DCSR"]["R"]}}</th>
                                <th colspan="3" id="nestedTable" style="border-right: solid 1px #9D9DAB; border-bottom: solid 1px #9D9DAB; color:#fff">{{this.getLanguage["DCSR"]["D"]}}</th>
                                <th colspan="5" id="nestedTable" style="border-right: solid 1px #9D9DAB; border-bottom: solid 1px #9D9DAB; color: #fff">{{this.getLanguage["DCSR"]["P"]}}</th>
                                <th colspan="2" id="nestedTable" style="border-top-right-radius: 5px; border-bottom: solid 1px #9D9DAB; color: #fff">{{this.getLanguage["DCSR"]["L"]}}</th>
                            </tr>
                            <tr>
                                <th id="nestedTableR2" class="tableCtnRight">{{this.getLanguage["DCSR"]["FD"]}}</th>
                                <th id="nestedTableR2" class="tableCtnRight">{{this.getLanguage["DCSR"]["D"]}}</th>
                                <th id="nestedTableR2" class="tableCtnRight" style="border-right: solid 1px #9D9DAB;">{{this.getLanguage["DCSR"]["UD"]}}</th>
                                <th id="nestedTableR2" class="tableCtnRight">{{this.getLanguage["DCSR"]["FD"]}}</th>
                                <th id="nestedTableR2" class="tableCtnRight">{{this.getLanguage["DCSR"]["ED"]}}</th>
                                <th id="nestedTableR2" class="tableCtnRight">{{this.getLanguage["DCSR"]["AFF"]}}</th>
                                <th id="nestedTableR2" class="tableCtnRight">{{this.getLanguage["DCSR"]["AR"]}}</th>
                                <th id="nestedTableR2" class="tableCtnRight" style="border-right: solid 1px #9D9DAB;">{{this.getLanguage["DCSR"]["DLS"]}}</th>
                                <th id="nestedTableR2" class="tableCtnRight" style="border-right: solid 1px #9D9DAB;">{{this.getLanguage["DCSR"]["M"]}}</th>
                                <th id="nestedTableR2" class="tableCtnRight" style="border-bottom-right-radius: 5px;">{{this.getLanguage["DCSR"]["A"]}}</th>
                            </tr>

                            <tr v-if="getUserInfo.AT == 4 && str_FV[1].FV">
                                <th colspan="2" id="nestedTableR3" class="" style="border-bottom-left-radius: 5px;border-top-left-radius:5px;">{{this.getLanguage["DCSR"]["T"]}}</th>
                                <th rowspan="1" id="nestedTableR3" class="tableCtnRight" style="border-right: solid 1px #9D9DAB;">{{ formatNumber(arry_dcstl.AM, 0) }}</th>
                                <th rowspan="1" id="nestedTableR3" class="tableCtnRight" style="border-right: solid 1px #9D9DAB;">{{ formatNumber(arry_dcstl.RC, 0) }}</th>
                                <th rowspan="1" id="nestedTableR3" class="tableCtnRight">{{ formatNumber(arry_dcstl.FDC, 0) }}</th>
                                <th rowspan="1" id="nestedTableR3" class="tableCtnRight">{{ formatNumber(arry_dcstl.DC, 0) }}</th>
                                <th rowspan="1" id="nestedTableR3" class="tableCtnRight" style="border-right: solid 1px #9D9DAB;">{{ formatNumber(arry_dcstl.UDC, 0) }}</th>
                                <th rowspan="1" id="nestedTableR3" class="tableCtnRight">{{ formatNumber(arry_dcstl.PFDC, 0) }}</th>
                                <th rowspan="1" id="nestedTableR3" class="tableCtnRight">{{ formatNumber(arry_dcstl.PEDC, 0) }}</th>
                                <th rowspan="1" id="nestedTableR3" class="tableCtnRight">{{ formatNumber(arry_dcstl.AFFC, 0) }}</th>
                                <th rowspan="1" id="nestedTableR3" class="tableCtnRight">{{ formatNumber(arry_dcstl.ARC, 0) }}</th>
                                <th rowspan="1" id="nestedTableR3" class="tableCtnRight" style="border-right: solid 1px #9D9DAB;">{{ formatNumber(arry_dcstl.DLSC, 0) }}</th>
                                <th rowspan="1" id="nestedTableR3" class="tableCtnRight" style="border-right: solid 1px #9D9DAB;">{{ formatNumber(arry_dcstl.MC, 0) }}</th>
                                <th rowspan="1" id="nestedTableR3" class="tableCtnRight" style="border-bottom-right-radius: 5px;border-top-right-radius:5px">{{ formatNumber(arry_dcstl.AC, 0) }}</th>
                            </tr>
                            <tr v-else="str_FV[0].FV">
                                <th colspan="2" id="nestedTableR3" class="" style="border-bottom-left-radius: 5px;border-top-left-radius:5px;">{{this.getLanguage["DCSR"]["T"]}}</th>
                                <th rowspan="1" id="nestedTableR3" class="tableCtnRight" style="border-right: solid 1px #9D9DAB;">{{ formatNumber(arry_dcstl.AM, 0) }}</th>
                                <th rowspan="1" id="nestedTableR3" class="tableCtnRight" style="border-right: solid 1px #9D9DAB;">{{ formatNumber(arry_dcstl.RC, 0) }}</th>
                                <th rowspan="1" id="nestedTableR3" class="tableCtnRight">{{ formatNumber(arry_dcstl.FDC, 0) }}</th>
                                <th rowspan="1" id="nestedTableR3" class="tableCtnRight">{{ formatNumber(arry_dcstl.DC, 0) }}</th>
                                <th rowspan="1" id="nestedTableR3" class="tableCtnRight" style="border-right: solid 1px #9D9DAB;">{{ formatNumber(arry_dcstl.UDC, 0) }}</th>
                                <th rowspan="1" id="nestedTableR3" class="tableCtnRight">{{ formatNumber(arry_dcstl.PFDC, 0) }}</th>
                                <th rowspan="1" id="nestedTableR3" class="tableCtnRight">{{ formatNumber(arry_dcstl.PEDC, 0) }}</th>
                                <th rowspan="1" id="nestedTableR3" class="tableCtnRight">{{ formatNumber(arry_dcstl.AFFC, 0) }}</th>
                                <th rowspan="1" id="nestedTableR3" class="tableCtnRight">{{ formatNumber(arry_dcstl.ARC, 0) }}</th>
                                <th rowspan="1" id="nestedTableR3" class="tableCtnRight" style="border-right: solid 1px #9D9DAB;">{{ formatNumber(arry_dcstl.DLSC, 0) }}</th>
                                <th rowspan="1" id="nestedTableR3" class="tableCtnRight" style="border-right: solid 1px #9D9DAB;">{{ formatNumber(arry_dcstl.MC, 0) }}</th>
                                <th rowspan="1" id="nestedTableR3" class="tableCtnRight" style="border-bottom-right-radius: 5px;border-top-right-radius:5px">{{ formatNumber(arry_dcstl.AC, 0) }}</th>
                            </tr>
                        </thead>

                        <tbody>
                        <td colspan="100%" v-if="!str_FV[0].FV && !str_FV[1].FV">{{this.getLanguage['GL']['PSAA']}}</td>
                        <tr v-for="(data,index) in arry_dcsrl" v-if="str_FV[0].FV || str_FV[1].FV">
                            <td>{{ CountItem(index+1) }}</td>
                            <td class="">{{ formatDateWithDay(data.RD) }}</td>
                            <td class="tableCtnRight">{{ formatNumber(data.AM, 0) }}</td>
                            <td class="tableCtnRight">{{ formatNumber(data.RC, 0) }}</td>
                            <td class="tableCtnRight">{{ formatNumber(data.FDC, 0) }}</td>
                            <td class="tableCtnRight">{{ formatNumber(data.DC, 0) }}</td>
                            <td class="tableCtnRight">{{ formatNumber(data.UDC, 0) }}</td>
                            <!--<td class="tableCtnRight">{{ formatNumber(data.PRC, 0) }}</td>-->
                            <td class="tableCtnRight">{{ formatNumber(data.PFDC, 0) }}</td>
                            <!--<td class="tableCtnRight">{{ formatNumber(data.PFDDC, 0) }}</td>-->
                            <td class="tableCtnRight">{{ formatNumber(data.PEDC, 0) }}</td>
                            <td class="tableCtnRight">{{ formatNumber(data.AFFC, 0) }}</td>
                            <td class="tableCtnRight">{{ formatNumber(data.ARC, 0) }}</td>
                            <td class="tableCtnRight">{{ formatNumber(data.DLSC, 0) }}</td>
                            <td class="tableCtnRight">{{ formatNumber(data.MC, 0) }}</td>
                            <td class="tableCtnRight">{{ formatNumber(data.AC, 0) }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { mapGetters, mapActions } from 'vuex'
    import DateRangePicker from 'vue2-daterange-picker'
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import Loading from 'vue-loading-overlay';
    import { required } from 'vuelidate/lib/validators'
    import genericHelper from "@/modules/GenericHelper.js";
    import moment from "moment";
    import { constAccessType, loadingFullScreen } from '@/modules/Constant.js'
    import Vue from 'vue'
    import $ from 'jquery'
    //Vue.use(require('vue-shortkey'))

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading
        },
        data() {
            return {
                bool_fullLoading: false, //Loading Visible
                bool_fullScreen: loadingFullScreen, //Full Screen
                int_RC: 100, //Row Count
                int_Page: 1,//current Page
                int_IC: 1, // Item Count
                str_tableSortBy: "RD", //(sort the table col name)
                bool_isSort: false,
                bool_showSearchBar: true,
                str_FV: [
                    { F: "AGI_csv" }, { F: "AGI", FV: null },
                    {
                        F: "RD",
                        FV: {
                            startDate: this.getMonthStartDate(),
                            endDate: this.getMonthEndDate()
                        }
                    }
                ], //Filter Value
                arry_dcsrl: [], //daily cs report list
                arry_dcstl: {
                    RC: 0,
                    FDC: 0,
                    DC: 0,
                    UDC: 0,
                    PFDC: 0,
                    PEDC: 0,
                    MC: 0,
                    AC: 0,
                    ARC: 0,
                    AFFC: 0,
                    DLSC: 0,
                    AM: 0,
                }, //daily cs total list
                dd_agentgroup: [],//agent group option,
                dd_subagentgroup: [],//agent group option
                ddDefaultSubBrand: [],
                rtSubBrand: 0,
                SearchAGI: null,
                constAccessType: constAccessType,
                hideBrand: false,
                disableSubDD: false
            }
        },
        created() {
            this.$parent.showSubMenu = 'R';
            this.$parent.showActiveMenu = 'R.DCSR';
            if (this.checkModuleIndex('DCSR', 'R', constAccessType.view, '', -1) == '7.2.6') {
                this.$parent.showSubSubMenu = 'RS2';
            } else if (this.checkModuleIndex('DCSR', 'R', constAccessType.view, '', -1) == '7.5.4') {
                this.$parent.showSubSubMenu = 'RS5';
            }

            this.hideBrand = this.getUserInfo.IHAGIF;
            if (this.getUserInfo.AT == 4) 
                this.loadDefaultSubBrand(0);
            

            this.getDailyCSReportList();
            this.getAgentGroup();
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['getUserInfo', 'checkModuleAccess', 'checkModuleIndex']),
        },
        methods: {
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.str_FV[2].FV.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.str_FV[2].FV.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.str_FV[2].FV.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.str_FV[2].FV.endDate = "";
                    }
                }
            },
            getAgentGroup() {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0/1`,
                    function (d, s) {
                        if (s) {
                            that.dd_agentgroup = that.deepClone(d.dropdownlist);

                            if (that.dd_agentgroup.length > 0) {
                                //that.dd_agentgroup.forEach(that.disableAgentGroupParent);

                                if (that.dd_agentgroup[0].children == undefined) {
                                    var at = 0;
                                    at = that.dd_agentgroup[0].id.split("-")[0];
                                    if (at == 3 && that.dd_agentgroup.length < 2) {
                                        that.SearchAGI = that.dd_agentgroup[0].id;
                                        that.AgentGroupChangefs([that.SearchAGI]);
                                    }
                                }
                            }
                        }
                    });
            },
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");
                if (agi[0] != "3") {
                    item.isDisabled = true;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },
            loadSubBrandOptions({ action, searchQuery, callback }) {
                var that = this;
                var parentAGI = 0;
                if (this.str_FV[0].FV) {
                    parentAGI = this.str_FV[0].FV;
                }
                else if (this.getUserInfo.AT === 4) {
                    parentAGI = 0;
                }
                else {
                    this.dd_subagentgroup = [];
                    callback(this.getLanguage['MEM']['PSAA']);
                    return;
                }

                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.dd_subagentgroup = [];
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${parentAGI}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.dd_subagentgroup = d.dropdownlist;
                            }
                            else {
                                that.dd_subagentgroup = [];
                            }
                            callback(null, that.dd_subagentgroup);
                        });
                }
            },
            loadDefaultSubBrand(agi) {
                var that = this;
                var searchQuery = "0";

                this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${agi}`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddDefaultSubBrand = d.dropdownlist;
                            that.str_FV[1].FV = that.ddDefaultSubBrand[0].id;
                            that.rtSubBrand = that.rtSubBrand == 0 ? 1 : 0;
                        }
                        else {
                            that.ddDefaultSubBrand = [];
                        }
                        that.getDailyCSReportList();
                    });
            },
            AgentGroupChangefs(value) {
                this.disableSubDD = false;
                this.str_FV[0].FV = null;
                this.str_FV[1].FV = null;
                if (value != undefined) {
                    var that = this;
                    var temp = "";

                    if (value != "") {
                        //agi = value.split("-")[1];
                        for (var x = 0; x < value.length; x++) {
                            if (x != 0) {
                                temp += ",";
                            }
                            var split = value[x].split("-");

                            if (split.length == 2) {
                                temp += split[1];
                            }
                            else {
                                temp += split[0];
                            }
                        }
                    }
                    that.str_FV[0].FV = temp;
                    if (value.length > 1) {
                        that.disableSubDD = true;
                    }
                }
                else {
                    this.str_FV[0].FV = null;
                    this.SearchAGI = null;
                }
                this.resizeTableHead();
            },
            SubAgentGroupChangefs(value) {
                if (value != undefined) {
                    var agi = 0;
                    if (value != "") {
                        agi = value;
                        this.str_FV[1].FV = agi;
                    }
                }
                else {
                    this.str_FV[1].FV = null;                    
                }
            },
            newsearch() {
                this.$refs.search.focus();
                if (this.str_FV[2].FV) {
                    if (this.str_FV[2].FV.startDate != "") {
                        var z = this.set90daysDateSearch(this.str_FV[2].FV.startDate);
                        if (z == true) {
                            return;
                        }

                    }
                }
                this.getDailyCSReportList();
            },
            getDailyCSReportList() {
                if (this.getUserInfo.AT == 4) {
                    if (!this.str_FV[1].FV)
                        return;
                } else {
                    if (!this.str_FV[0].FV)
                        return;
                }
                this.bool_fullLoading = true;
                var that = this;

                var param = {
                    "p": this.int_Page,
                    "n": this.int_RC,
                    "s": this.str_tableSortBy,
                    "d": this.bool_isSort,
                    "f": {
                        "AGI_csv": this.str_FV[0].FV,
                        "AGI": this.str_FV[1].FV,
                        "RD_from": (this.str_FV[2].F == 'RD' && this.str_FV[2].FV != '') ? this.parseDateToJsonString(this.str_FV[2].FV.startDate) : "",
                        "RD_to": (this.str_FV[2].F == 'RD' && this.str_FV[2].FV != '') ? this.parseDateToJsonString(this.str_FV[2].FV.endDate) : "",
                    }
                }

                if (this.str_FV[1].FV > 0) {
                    this.postDataApi(`/api/dcsr/subAgent/lr`, param, function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.setDailyCSReportList(d.D);
                            that.resizeTableHead();
                        }
                    });
                    this.postDataApi(`/api/dcsr/subAgent/lr/total`, param, function (data, s) {
                        if (s) {
                            that.bool_fullLoading = false;
                            that.setDailyCSSummaryList(data.D);
                        }
                    });
                } else {
                    this.postDataApi(`/api/dcsr/lr`, param, function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.setDailyCSReportList(d.D);
                            that.resizeTableHead();
                        }
                    });

                    this.postDataApi(`/api/dcsr/lr/total`, param, function (data, s) {
                        if (s) {
                            that.bool_fullLoading = false;
                            that.setDailyCSSummaryList(data.D);
                        }
                    });
                }
            },
            setDailyCSReportList(data) {
                this.arry_dcsrl = data.Items;
            },
            setDailyCSSummaryList(data) {
                if (data.Items.length != 0 && data.Items.length != null) {
                    this.arry_dcstl = data.Items[0];
                }
                else {
                    this.arry_dcstl = {
                        RC: 0,
                        FDC: 0,
                        DC: 0,
                        UDC: 0,
                        PFDC: 0,
                        PEDC: 0,
                        MC: 0,
                        AC: 0,
                        ARC: 0,
                        AFFC: 0,
                        DLSC: 0,
                        AM: 0,
                    }
                }

            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending
                this.getDailyCSReportList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            formatDateWithDay(date) {
                var day = moment(date).format('dddd');
                var dayMapping = {
                    'Monday': 'WD1',
                    'Tuesday': 'WD2',
                    'Wednesday': 'WD3',
                    'Thursday': 'WD4',
                    'Friday': 'WD5',
                    'Saturday': 'WD6',
                    'Sunday': 'WD7'
                };
                var dayNumber = dayMapping[day];
                var formatteddate = moment(date).format('ll');
                return this.getLanguage['GL'][dayNumber] + ', ' + formatteddate;
            },
            clearDateRangeFilter() {
                this.str_FV[2].FV = {
                    startDate: this.getMonthStartDate(),
                    endDate: this.getMonthEndDate()
                };
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('EPE', 'R', type);
            },
            saveToExcel() {

                var param = {
                    "p": this.int_Page,
                    "n": this.int_RC,
                    "s": this.str_tableSortBy,
                    "d": this.bool_isSort,
                    "f": {
                        "AGI_csv": this.str_FV[0].FV,
                        "AGI": this.str_FV[1].FV,
                        "RD_from": (this.str_FV[2].F == 'RD' && this.str_FV[2].FV != '') ? this.parseDateToJsonString(this.str_FV[2].FV.startDate) : "",
                        "RD_to": (this.str_FV[2].F == 'RD' && this.str_FV[2].FV != '') ? this.parseDateToJsonString(this.str_FV[2].FV.endDate) : "",
                    }
                }
                var form = document.createElement("form");
                form.method = "POST";
                form.action = "/api/dcsr/dailycsexcel";
                form.target = "_blank";

                for (var key in param) {
                    if (param.hasOwnProperty(key) && key == "f") {
                        for (var fkey in param['f']) {
                            var hiddenField = document.createElement('input');
                            hiddenField.type = "hidden";
                            hiddenField.name = key + '[' + fkey + ']'
                            hiddenField.value = param['f'][fkey];
                            form.appendChild(hiddenField);
                        }
                    }
                    else if (param.hasOwnProperty(key)) {
                        var hiddenField = document.createElement('input');
                        hiddenField.type = "hidden";
                        hiddenField.name = key;
                        hiddenField.value = param[key];
                        form.appendChild(hiddenField);
                    }
                }

                document.body.appendChild(form);
                form.submit();
                //var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                //for (var i = 0; i < this.str_FV.length; i++) {
                //    if (this.str_FV[i].FV) {
                //        if (path) {
                //            path += "&";
                //        }
                //        if (this.str_FV[i].FA && this.str_FV[i].FV) {
                //            path += ("f[" + this.str_FV[i].F + "][]=" + this.str_FV[i].FV);
                //        }
                //        else if (this.str_FV[i].F == 'RD' && this.str_FV[i].FV != '') {
                //            if (this.str_FV[i].FV.startDate != "") {
                //                var rd_from = this.parseDateToJsonString(this.str_FV[i].FV.startDate);
                //                path += "f[RD_from]=" + rd_from;
                //            }
                //            if (this.str_FV[i].FV.endDate != "") {
                //                var rd_to = this.parseDateToJsonString(this.str_FV[i].FV.endDate);
                //                path += "&f[RD_to]=" + rd_to;
                //            }
                //        }
                //        else {
                //            path += ("f[" + this.str_FV[i].F + "]=" + this.str_FV[i].FV);
                //        }
                //    }
                //};
                //window.open('/api/dcsr/dailycsexcel?' + path, '_blank');
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);

                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const allHeaderRows = this.$el.querySelectorAll('#tHead .custom-table thead tr');

                if (!allHeaderRows.length) return; // Early return if no header rows

                tables.forEach((table) => {
                    let nestedIndex = 0;

                    // Collect body cells from the first row
                    const bodyCells = Array.from(table.querySelectorAll('tbody tr:nth-child(1) td'));
                    if (!bodyCells.length) return; // Early return if no body cells

                    // Reset all widths before applying new ones
                    const bodyCellElements = table.querySelectorAll('tbody tr td');
                    [...allHeaderRows[0].querySelectorAll('th'), ...bodyCellElements].forEach(cell => cell.style.width = '');

                    // Apply widths to header and body cells
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        const isNested = [4, 5, 6, 7, 8, 9, 10, 11, 12, 13].includes(index);
                        const headerRow = isNested ? 2 : 1;
                        const headerCells = this.$el.querySelectorAll(`#tHead .custom-table thead tr:nth-child(${headerRow}) th`);

                        let headerCell = headerCells[isNested ? nestedIndex : index];
                        if (headerCell) {
                            headerCell.style.width = width;
                        }

                        // Update body cell styles for the corresponding column
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach((td) => {
                            td.style.width = width;
                        });

                        // Increment nestedIndex for nested columns
                        if (isNested) nestedIndex++;
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
        },
        watch: {
            getLanguage() {
                this.getDailyCSReportList();
            },
        },

    }

</script>

<style>
    .csReport #nestedTableR2 {
        top: 20.5px;
    }
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/Reports/DailyCSReport.vue